import { IconChevronRight16, Label, UIHeading2, UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PurchaseTermCell.css';
import { IDescriptionDialog } from '../../types/purchaseTerm';

interface IPurchaseTermCellProps {
  title: string;
  price: string;
  pricePerMeter: string;
  label?: string | null;
  onClick(): void;
  descriptionDialog?: IDescriptionDialog;
}

export const PurchaseTermCell: React.FC<IPurchaseTermCellProps> = ({ title, price, pricePerMeter, label, onClick }) => {
  return (
    <div className={styles['price-cell']} onClick={onClick} data-testid="PurchaseTermCell">
      <div className={styles['inner']}>
        <div className={styles['price-info']}>
          <div className={styles['purchase-type']}>
            <UIHeading5>{title}</UIHeading5>
            {label && (
              <Label background="text-inverted-default" color="text-main-default">
                {label}
              </Label>
            )}
          </div>
          <div className={styles['purchase-price']}>
            <UIHeading2>{price}</UIHeading2>
            <UIText2 color="text-secondary-default">{pricePerMeter}</UIText2>
          </div>
        </div>
        <div className={styles['chevron']}>
          <IconChevronRight16 color="icon-main-default" />
        </div>
      </div>
    </div>
  );
};
